import React from "react";
import { Navigate } from "react-router";

import Auth from "../../views/layouts/Auth";
import ConfirmEmail from "../../views/pages/auth/ConfirmEmail";
import ConfirmNewsletterUnsubscription from "../../views/pages/auth/ConfirmNewsletterUnsubscription";
import ConfirmUserRemoval from "../../views/pages/auth/ConfirmUserRemoval";
import ForgottenPassword from "../../views/pages/auth/ForgottenPassword";
import Login from "../../views/pages/auth/Login";
import ResetPassword from "../../views/pages/auth/ResetPassword";
import SignUp from "../../views/pages/auth/SignUp";

const subRoutes = [
  {
    path: "login",
    authorize: ["unAuth"],
    component: <Login />,
  },
  {
    path: "signup",
    authorize: ["unAuth"],
    component: <SignUp />,
  },
  {
    path: "signup/distributor",
    authorize: ["unAuth"],
    component: <SignUp asDistributor />,
  },
  {
    path: "confirm-email",
    component: <ConfirmEmail />,
  },
  {
    path: "forgotten-password",
    component: <ForgottenPassword />,
  },
  {
    path: "reset-password",
    component: <ResetPassword />,
  },
  {
    path: "confirm-user-removal",
    component: <ConfirmUserRemoval />,
  },
  {
    path: "confirm-newsletter-unsubscription",
    component: <ConfirmNewsletterUnsubscription />,
  },
  {
    path: "*",
    index: true,
    authorize: ["unAuth"],
    component: <Navigate to="/auth/login" replace />,
  },
  {
    path: "*",
    index: true,
    component: <Navigate to="/" replace />,
  },
];

const index = () => ({
  path: "/auth",
  component: <Auth />,
  subRoutes: subRoutes,
});

export default index;
